export const genders = [
  {
    id: 0,
    value: 'male',
    label: 'Male'
  },
  {
    id: 1,
    value: 'female',
    label: 'Female'
  },
  {
    id: 2,
    value: 'other',
    label: 'Other'
  },
  {
    id: 3,
    value: 'non_binary',
    label: 'Non-Binary'
  },
  {
    id: 4,
    value: 'transgender',
    label: 'Transgender'
  },
  {
    id: 5,
    value: 'prefer_not_to_respond',
    label: 'Prefer not to respond'
  }
];

export const races = [
  {
    id: 0,
    value: 'American Indian or Alaska Native',
    label: 'American Indian or Alaska Native'
  },
  {
    id: 1,
    value: 'Asian',
    label: 'Asian'
  },
  {
    id: 2,
    value: 'Black or African American',
    label: 'Black or African American'
  },
  {
    id: 3,
    value: 'Hispanic or Latino',
    label: 'Hispanic or Latino'
  },
  {
    id: 4,
    value: 'Native Hawaiian or Other Pacific Islander',
    label: 'Native Hawaiian or Other Pacific Islander'
  },
  {
    id: 5,
    value: 'White',
    label: 'White'
  }
];

export const marital_status = [
  {
    id: 0,
    value: 'Married',
    label: 'Married'
  },
  {
    id: 1,
    value: 'Widowed',
    label: 'Widowed'
  },
  {
    id: 2,
    value: 'Separated',
    label: 'Separated'
  },
  {
    id: 3,
    value: 'Divorced',
    label: 'Divorced'
  },
  {
    id: 4,
    value: 'Single',
    label: 'Single'
  }
];

export const employmentType = [
  {
    value: 'Y',
    label: 'Employed'
  },
  {
    value: 'N',
    label: 'Unemployed'
  }
];

export const pronounOptions = [
  { value: 'he-him', label: 'He/Him' },
  { value: 'she-her', label: 'She/Her' },
  { value: 'they-them', label: 'They/Them' }
];

export const tax_id_types = [
  {
    value: 'E',
    label: 'EIN'
  },
  {
    value: 'S',
    label: 'SSN'
  }
];

export const practice_kinds = [
  {
    value: 'medical',
    label: 'Medical'
  },
  {
    value: 'dental',
    label: 'Dental'
  },
  {
    value: 'vision',
    label: 'Vision'
  }
];

export const practice_status = [
  {
    value: 'pending',
    label: 'Pending'
  },
  {
    value: 'active',
    label: 'Active'
  },
  {
    value: 'inactive',
    label: 'Inactive'
  }
];

export const US_ZIP_PATTERN = /^\d{5}(?:-\d{4})?$/;

export const SEX_AT_BIRTH_OPTIONS = [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' },
  { value: 'unknown', label: 'Unknown' },
  { value: 'declined', label: 'Declined to answer' }
];

export const GENDER_IDENTITY_OTHER = 'other';

export const RACE_DECLINED = 'Declined to answer';

export const GENDER_IDENTITY_OPTIONS = [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' },
  { value: 'transgender_female', label: 'Transgender female' },
  { value: 'transgender_male', label: 'Transgender male' },
  { value: 'non_binary', label: 'Non-binary' },
  { value: GENDER_IDENTITY_OTHER, label: 'Other' },
  { value: 'declined', label: 'Declined to answer' }
];

export const GENDER_IDENTITY_TO_GENDER = {
  female: 'female',
  male: 'male',
  transgender_female: 'transgender',
  transgender_male: 'transgender',
  non_binary: 'non_binary',
  declined: 'prefer_not_to_respond'
};

export const RACE_OPTIONS = [
  { value: 'American Indian or Alaska Native', label: 'American Indian or Alaska Native' },
  { value: 'Asian', label: 'Asian' },
  { value: 'Black or African American', label: 'Black or African American' },
  {
    value: 'Native Hawaiian or Other Pacific Islander',
    label: 'Native Hawaiian or Other Pacific Islander'
  },
  { value: 'White', label: 'White' },
  { value: 'Other', label: 'Other' },
  { value: RACE_DECLINED, label: RACE_DECLINED }
];

export const ETHNICITY_OPTIONS = [
  { value: 'hispanic_or_latino', label: 'Hispanic or Latino' },
  { value: 'not_hispanic_or_latino', label: 'Not Hispanic or Latino' },
  { value: 'declined', label: 'Declined to answer' }
];

export const PHONE_REGEX = /^(\+?1[-.\s]?)?(\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/;

export const CUSTOM_CHART_ID_REGEX = /^[a-zA-Z0-9!@#$%^&*()-]*$/;
